import Component from '@glimmer/component';
import { IDAFMonthly, IDAFWeekly } from 'volta/models/types/planning-settings';

interface IArgs {
  dafMonthly?: IDAFMonthly;
  dafWeekly?: IDAFWeekly;
  micro?: boolean;
  bgHue?: string;
}

const dafValueFn = (values: IDAFWeekly | IDAFMonthly, i: number) => {
  return values[`${i + 1}` as keyof (IDAFMonthly | IDAFWeekly)] ?? 1.0;
};

export default class DafCalendarMini extends Component<IArgs> {
  get bgHue() {
    return this.args.bgHue ?? 'var(--bv-color-teal-4-rgb)';
  }

  get isWeekly() {
    return Boolean(this.args.dafWeekly);
  }

  get periods() {
    const { dafMonthly, dafWeekly } = this.args;
    return Array(this.isWeekly ? 53 : 12)
      .fill(1.0)
      .map((_, i) => dafValueFn(dafWeekly ?? dafMonthly ?? {}, i));
  }

  get periodsSlices() {
    const { periods = [], isWeekly } = this;
    const columns = isWeekly ? 18 : 4;
    return Array(columns)
      .fill([])
      .map((_, i) => {
        return periods.slice(columns * i, columns * (i + 1));
      });
  }
}
